<template>
  <v-card
    tile
    v-if="settings"
    elevation="0"
    :height="settings.bg && settings.bg.height ? settings.bg.height : 'calc(100vh - 80px)'"
    :color="MIXIN_getBgInfo(settings, 'color')"
    :img="MIXIN_getBgInfo(settings, 'image')"
    style="position: relative;"
  >
    <video
      v-if="MIXIN_isVideoBg(settings)"
      autoplay
      muted
      loop
      id="myVideo"
    >
      <source :src="MIXIN_getBgInfo(settings, 'video')" type="video/mp4"/>
    </video>

    <section :class="[
      'alignment-container pa-4', 
      {'justify-end': settings['text-position'] === 'right'},
      {'justify-center': settings['text-position'] === 'center'},
      {'justify-start': settings['text-position'] === 'left'},
      {'align-start': settings['text-position-vertical'] === 'start'},
      {'align-center': settings['text-position-vertical'] === 'center'},
      {'align-end': settings['text-position-vertical'] === 'end'},
    ]">
      <div :class="['alignment-content', {'alignment-content-small-screens': !$vuetify.breakpoint.mdAndUp}]">
        <div style="width: 100%">
          <v-img
            v-if="settings.logo"
            class="mb-6"
            contain
            eager
            max-width="100vw"
            :height="settings.logo_height"
            :src="settings.logo"
            :position="settings.logo_alignment"
          ></v-img>
        </div>
        
        <div 
          :class="[
            'align-item', 
            {'justify-start': settings.title.alignment === 'left'}, 
            {'justify-center': settings.title.alignment === 'center'}, 
            {'justify-end': settings.title.alignment === 'right'}
          ]"
        >
          <h1
            class="mb-3"
            :style="
              `
              font-family: ${MIXIN_getStyle(settings, 'title', 'font')} !important; 
              font-size: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
              color: ${MIXIN_getStyle(settings, 'title', 'color')} !important; 
              line-height: ${MIXIN_getStyle(settings, 'title', 'font-size')} !important; 
              font-weight: ${MIXIN_getStyle(settings, 'title', 'weight')} !important;
              font-style: ${MIXIN_getStyle(settings, 'title', 'font-style')} !important;
              `
            "
          >
            {{ settings.title.content }}
          </h1>
        </div>

        <div 
          :class="[
            'align-item',
            {'text-left': settings.text.alignment === 'left'}, 
            {'text-center': settings.text.alignment === 'center' || !settings.text.alignment}, 
            {'text-right': settings.text.alignment === 'right'}
          ]"
        >
          <span style="width: 100%" v-html="formatedText"></span>
        </div>

        <div
          v-if="haveButtons" 
          style="gap: 16px"
          :class="[
            'align-item pt-4',
            {'justify-start': settings['button-alignment'] === 'left'}, 
            {'justify-center': settings['button-alignment'] === 'center' || !settings['button-alignment']}, 
            {'justify-end': settings['button-alignment'] === 'right'}
          ]"
        >
          <span v-for="(item, index) in settings.buttons" :key="index">
            <v-btn
              v-if="item.caption && item.action"
              class="mt-0"
              target="_blank"
              elevation="0"
              height="44px"
              :style="
                `
                background-color: ${MIXIN_getStyle(settings, 'button', 'background-color', index)} !important;
                border-radius: ${MIXIN_getStyle(settings, 'button', 'border-radius', index)} !important
                `
              "
              :loading="oneCheckoutOpen"
              @click="actionButton(index)"
              >
                <b
                  :style="
                    `
                    color: ${MIXIN_getStyle(settings, 'button', 'color', index)} !important;
                    `
                  "
                  >
                  {{ item.caption }}
                </b>
            </v-btn>
          </span>
        </div>
      </div>
    </section>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import {GetLayoutSectionMixin} from "../../mixins/GetLayoutSection"

export default {
  mixins: [GetLayoutSectionMixin],
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters(["infos", "oneCheckoutOpen"]),
    formatedText() {
      if (this.settings.text.content) {
        let content = this.settings.text.content 
        if (!content.includes('<p>') && !content.includes('</p>')) content = `<p>${content}</p>`
        const formated = content
          .replaceAll(
            '<p>',
            `<span style="
              display: block;
              font-family: ${this.MIXIN_getStyle(this.settings, 'text', 'font')} !important; 
              font-size: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              color: ${this.MIXIN_getStyle(this.settings, 'text', 'color')} !important; 
              line-height: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              font-weight: ${this.MIXIN_getStyle(this.settings, 'text', 'weight')} !important;
              font-style: ${this.MIXIN_getStyle(this.settings, 'text', 'font-style')} !important;
            ">`
          )
          .replaceAll('</p>', "</span>")
        return formated
      } else return ""
    },

    haveButtons () {
      const checkButtons = this.settings.buttons.some(btn => btn.caption && btn.action)
      return checkButtons
    }
  },

  methods: {
    emitScroll(item) {
      this.$emit("handleScrollTo", item.action);
    },

    actionButton(index) {
      if (
        this.settings.buttons[index].action &&
        this.settings.buttons[index].action.charAt(0) === "#"
      )
        this.$vuetify.goTo(this.settings.buttons[index].action);
      else if (this.settings.buttons[index].action === "Abrir Checkout") {
        this.openCheckout()
      }
      else if (this.settings.buttons[index].action.includes('page-')) {
        const page = this.infos.pages.find(page => page.id === this.settings.buttons[index].action)
        if (page) {
          this.$router.push({name: 'CustomBodyPage', params: {page: page.route.split('/')[1]}})
          this.$store.dispatch('setSelectedPage', this.settings.buttons[index].action)
        }
      } else {
        let url = this.settings.buttons[index].action
        if (!url.includes('http://') || !url.includes('https://')) url = `https://${url}`
        window.open(url, '_blank')
      }   
    },

    openCheckout() {
      this.$store.dispatch("setOneCheckoutOpen", true);
    },
  },
};
</script>

<style scoped>
.alignment-container {
  position: absolute; 
  display: flex; 
  justify-content: center; 
  align-items: center; 
  /* background-color: red;  */
  z-index: 99999 !important; 
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.alignment-content {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center; 
  align-items: center; 
  text-align: center;
  max-width: 1340px !important;
}

.alignment-content-small-screens {
  max-width: 90% !important;
}

.align-item {
  display: flex;
  flex-wrap: wrap;
  width: 100% !important;
}

span {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.15000000596046448px;
}

h1 {
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: 0px;
}

.v-btn {
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0.75px;
  text-align: center;
}

#myVideo {
  position: absolute;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>
